import React, { Component } from 'react';
import * as localeDictionary from 'plotly.js/lib/locales/fr';
import BibliothequePlotly from '../BibliothequePlotly/BibliothequePlotly';

const CARDINALS = ['N', 'NNE', 'NE', 'ENE', 'E', 'ESE', 'SE', 'SSE', 'S', 'SSW', 'SW', 'WSW', 'W', 'WNW', 'NW', 'NNW'];

class WindRose extends Component {
  state = {
    afficherRangeSlider: true,
    afficherModeBar: false,
    data: [],
    layout: {},
  };

  // Récupérer la liste des points cardinaux en fonction du nombre de secteurs sélectionné.
  getCardinals(sectors_count) {
    
    if (![4, 8, 16].includes(sectors_count)){
      sectors_count = 4;
    }
    const step = Math.floor(CARDINALS.length / sectors_count);
    let graph_cardinals = [];
    for (let i = 0 ; i < CARDINALS.length ; i += step ){
      graph_cardinals.push(CARDINALS[i]);
    }
    return graph_cardinals;
  };

  render() {
    // Configuration par défaut
    const defaultBins = ['0-5', '6-10', '11-15', '16-30', '>30'];

    const defaultColors = [
      '#D2F2D4',
      '#7BE382',
      '#26CC00',
      '#22B600',
      '#009C1A',
    ];
    
    // Paramètres du graph
    let directions = CARDINALS;
    let bins = defaultBins;
    let frequencies = null;
    let colors = defaultColors;
    let hasValidData = false;

    console.log(this.props.configuration.xaxis.range, this.props.configuration.xaxis.range.length);

    // Gérer le nombre de secteur à afficher
    let sectorsCount = parseInt(this.props.configuration.yaxis.range[0]);
    if (sectorsCount === null){
      sectorsCount = 8;
    }

    // Traitement des données dans le format standardisé Argos
    if (this.props.donnees && Array.isArray(this.props.donnees)) {
      // Chercher les données de direction du vent
      const windDirectionData = this.props.donnees.find(
        (dataset) =>
          dataset.prefix === 'Direction du vent' ||
          dataset.prefix === 'wind_direction' ||
          (dataset.engineering_unit === '°' &&
            (dataset.sensor_name?.toLowerCase().includes('direction') ||
              dataset.name?.toLowerCase().includes('direction')))
      );

      // Chercher les données de vitesse du vent
      const windSpeedData = this.props.donnees.find(
        (dataset) =>
          dataset.prefix === 'Vitesse du vent' ||
          dataset.prefix === 'wind_speed' ||
          (['m/s', 'km/h', 'mph', 'kt'].includes(dataset.engineering_unit) &&
            (dataset.sensor_name?.toLowerCase().includes('vitesse') ||
              dataset.sensor_name?.toLowerCase().includes('speed') ||
              dataset.name?.toLowerCase().includes('vitesse') ||
              dataset.name?.toLowerCase().includes('speed')))
      );

      console.log(
        'Direction data found:',
        windDirectionData?.prefix,
        windDirectionData?.engineering_unit
      );

      console.log(
        'Speed data found:',
        windSpeedData?.prefix,
        windSpeedData?.engineering_unit
      );

      

      if (windDirectionData && windSpeedData) {
        // Traiter les données réelles pour créer la rose des vents
        const processedData = this.processWindData(
          windDirectionData,
          windSpeedData,
          sectorsCount
        );
        if (processedData) {
          directions = processedData.directions;
          bins = processedData.bins;
          frequencies = processedData.frequencies;
          hasValidData = true;
        }
      }
    }

    
    // Gérer la range du radial axis ([min, max] %)
    let autoRange = true; // Gestion automatique de la range si xaxis.range est [null]
    let xAxisRange = [null, null];
    if (this.props.configuration.xaxis.range[0] === null || this.props.configuration.xaxis.range[1] == null){
      autoRange = true;
    }else{
      xAxisRange = this.props.configuration.xaxis.range;
      autoRange = false;
      xAxisRange[0] = Math.max(xAxisRange[0] , 0);
      xAxisRange[1] = Math.min(xAxisRange[1] , 100);
    }
    
    // Si pas de données valides, afficher un message détaillé
    if (!hasValidData) {
      let errorMessage =
        'Aucune donnée de vent disponible pour générer la rose des vents';
      let detailMessage = '';

      if (this.props.donnees && Array.isArray(this.props.donnees)) {
        const windSpeedData = this.props.donnees.find(
          (d) => d.prefix === 'vitesse du vent' || d.prefix === 'wind_speed'
        );

        if (windSpeedData && windSpeedData.y) {
          const maxSpeed = Math.max(
            ...windSpeedData.y.filter((v) => v !== null && !isNaN(v))
          );
          const minSpeed = Math.min(
            ...windSpeedData.y.filter((v) => v !== null && !isNaN(v))
          );
          const avgSpeed =
            windSpeedData.y.reduce((a, b) => a + (b || 0), 0) /
            windSpeedData.y.length;

          if (maxSpeed === 0) {
            detailMessage = `Toutes les vitesses de vent sont à 0 m/s (${windSpeedData.y.length} mesures)`;
          } else {
            detailMessage = `Vitesses : min=${minSpeed}, max=${maxSpeed}, moy=${avgSpeed.toFixed(
              1
            )} m/s`;
          }
        }
      }

      return (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '400px',
            fontSize: '16px',
            color: '#666',
            textAlign: 'center',
            padding: '20px',
          }}
        >
          <div>{errorMessage}</div>
          {detailMessage && (
            <small
              style={{ marginTop: '10px', fontSize: '12px', color: '#999' }}
            >
              {detailMessage}
            </small>
          )}
          <small style={{ marginTop: '10px', fontSize: '12px', color: '#999' }}>
            Recherche : "Direction du vent" (°) + "vitesse du vent" (m/s)
          </small>
        </div>
      );
    }

    // Récupération des configurations JSON
    let jsonLayout = {};
    let styleData = {};
    if (this.props.viewobj_json_content !== undefined) {
      if (this.props.viewobj_json_content.layout !== undefined) {
        jsonLayout = this.props.viewobj_json_content.layout;
      }
      if (this.props.viewobj_json_content.styleData !== undefined) {
        styleData = this.props.viewobj_json_content.styleData;
      }
    }

    // Définition du titre du graphique
    let title = 'Rose des vents (fréquence des vitesses)';
    let subtitle = '';
    if (
      this.props.configuration !== undefined &&
      this.props.configuration.title !== undefined
    ) {
      title = this.props.configuration.title;
      subtitle = this.props.configuration.subtitle || '';
    }

    // Gestion de la visibilité de la légende
    let showlegend = true;
    if (
      this.props.configuration !== undefined &&
      this.props.configuration.showlegend !== undefined
    ) {
      showlegend = this.props.configuration.showlegend === 1;
    }

    // Préparation des données pour Plotly
    const data = bins.map((bin, i) => {
      // Création de textes personnalisés pour les hover
      let text = [];
      let engineering_unit = 'm/s';

      // Récupérer l'unité d'ingénierie depuis les données de vitesse
      if (this.props.donnees && Array.isArray(this.props.donnees)) {
        const speedData = this.props.donnees.find(
          (dataset) =>
            dataset.prefix === 'vitesse du vent' ||
            dataset.prefix === 'wind_speed' ||
            ['m/s', 'km/h', 'mph', 'kt'].includes(dataset.engineering_unit)
        );
        if (speedData && speedData.engineering_unit) {
          engineering_unit = speedData.engineering_unit;
        }
      }

      frequencies[bin].forEach((value, index) => {
        const directionName = directions[index];
        const formattedValue = parseFloat(value);

        // Format des infobulles avec nom du capteur
        const sensorName =
          this.props.donnees && Array.isArray(this.props.donnees)
            ? this.props.donnees[0]?.sensor_name || 'Rose des vents'
            : 'Rose des vents';

        let infoBulle = [
          sensorName,
          `Direction: ${directionName}`,
          `Vitesse ${bin} ${engineering_unit}: ${formattedValue}%`,
        ];
        text.push(infoBulle.join('<br>'));
      });

      return {
        type: 'barpolar',
        r: frequencies[bin],
        theta: directions,
        name: `${bin} ${engineering_unit}`,
        marker: { color: colors[i % colors.length] },
        hovertemplate: '%{text}<extra></extra>',
        text: text,
        ...styleData,
      };
    });

    // Configuration du layout
    const layout = {
      title: {
        text: title + (subtitle ? '<br>' + subtitle : ''),
      },
      responsive: true,
      width:
        this.props.dimensionWidth !== undefined
          ? this.props.dimensionWidth
          : window.innerWidth * 0.75,
      height:
        this.props.dimensionHeight !== undefined
          ? this.props.dimensionHeight
          : window.innerHeight * 0.85,
      font: { size: 14 },
      polar: {
        barmode: 'stack',
        angularaxis: {
          direction: 'clockwise',
          ...(jsonLayout.polar && jsonLayout.polar.angularaxis
            ? jsonLayout.polar.angularaxis
            : {}),
        },
        radialaxis: {
          ticksuffix: '%',
          autorange: autoRange,
          range: xAxisRange,
          ...(jsonLayout.polar && jsonLayout.polar.radialaxis
            ? jsonLayout.polar.radialaxis
            : {}),
        },
        ...(jsonLayout.polar ? jsonLayout.polar : {}),
      },
      showlegend: showlegend,
      legend: {
        orientation: 'h',
        x: .5,
        y: -.2,
        xanchor: 'center',
        yanchor: 'top',
        borderwidth: 1,
        entrywidthmode: 'pixels',
        entrywidth: 20,
        ...(jsonLayout.legend ? jsonLayout.legend : {}),
      },
      margin:{
        t:120,
        b:80
      },
      modebar: {
        orientation: 'h',
        bgcolor: 'rgba(0, 0, 0, 0)',
        color: 'black',
        activecolor: '#f0af00',
        ...(jsonLayout.modebar ? jsonLayout.modebar : {}),
      },
      ...jsonLayout,
    };

    return (
      <BibliothequePlotly
        data={data}
        layout={layout}
        donneesGraphe={this.props.donneesGraphe}
        ouvrirPopupModifierIntervalle={
          this.props.switchAfficherModifierIntervalle
        }
        dimensionWidth={this.props.dimensionWidth}
        dimensionHeight={this.props.dimensionHeight}
        viewobj_json_content={this.props.viewobj_json_content}
        config={{
          locales: { fr: localeDictionary },
          locale: 'fr',
          displayModeBar:
            this.props.viewobj_json_content === undefined ||
            this.props.viewobj_json_content === null
              ? true
              : this.props.viewobj_json_content.length === 0 ||
                this.props.viewobj_json_content.displayModeBar === true
              ? true
              : false,
          displaylogo: false,
          modeBarButtonsToRemove: [''],
        }}
        afficherModeBar={() =>
          this.setState({
            afficherManuelMode: true,
            afficherModeBar: !this.state.afficherModeBar,
          })
        }
        modeBar={this.state.afficherModeBar}
      />
    );
  }

  // Méthode pour traiter les données de vent réelles
  processWindData = (windDirectionData, windSpeedData, sectorsCount) => {
    try {
      // Configuration avec 16 directions et bins adaptés pour les faibles vitesses
      let directions = [
        'N',
        'NNE',
        'NE',
        'ENE',
        'E',
        'ESE',
        'SE',
        'SSE',
        'S',
        'SSW',
        'SW',
        'WSW',
        'W',
        'WNW',
        'NW',
        'NNW',
      ];

      // Directions à afficher selon le nombre de secteurs choisi
      directions = this.getCardinals(sectorsCount);

      const bins = ['0-5', '6-10', '11-15', '16-30', '>30'];

      // Vérifier que les données existent
      if (
        !windDirectionData.y ||
        !windSpeedData.y ||
        windDirectionData.y.length === 0 ||
        windSpeedData.y.length === 0
      ) {
        console.warn('Données de vent manquantes ou vides');
        return null;
      }

      // Initialiser les compteurs de fréquences
      const frequencies = {};
      bins.forEach((bin) => {
        frequencies[bin] = new Array(directions.length).fill(0);
      });

      // Nombre de secteurs directionnels (16 secteurs de 22.5°)
      const nbDirections = directions.length;
      const angleParSecteur = 360 / nbDirections;

      // Traiter chaque point de données
      const dataLength = Math.min(
        windDirectionData.y.length,
        windSpeedData.y.length
      );
      let validDataCount = 0;
      let zeroSpeedCount = 0;

      console.log(`Traitement de ${dataLength} points de données...`);

      for (let i = 0; i < dataLength; i++) {
        const direction = windDirectionData.y[i];
        const speed = windSpeedData.y[i]; // Conversion possible ici

        // Vérifier que les valeurs sont valides
        if (
          direction != null &&
          speed != null &&
          !isNaN(direction) &&
          !isNaN(speed) &&
          direction >= 0 &&
          direction <= 360 &&
          speed >= 0
        ) {
          validDataCount++;

          if (speed === 0) zeroSpeedCount++;

          // Calculer l'index du secteur de direction (0-15)
          const directionIndex = Math.floor(
            (direction % 360) / angleParSecteur
          );

          // Déterminer la tranche de vitesse (bins adaptés pour faibles vitesses)
          let speedBin = '';
          if (speed >= 0 && speed <= 5) speedBin = '0-5';
          else if (speed >= 6 && speed <= 10) speedBin = '6-10';
          else if (speed >= 11 && speed <= 15) speedBin = '11-15';
          else if (speed >= 16 && speed <= 30) speedBin = '16-30';
          else if (speed > 30) speedBin = '>30';

          // Incrémenter le compteur si la vitesse correspond à une tranche
          if (speedBin && frequencies[speedBin]) {
            frequencies[speedBin][directionIndex]++;
          }
        }
      }

      let count_by_direction = {};
      // Nombre de points par direction
      directions.forEach((d) => {
        count_by_direction[d] = 0;
      });

      for (let i=0; i<16; i++){
        bins.forEach((b) => {
          count_by_direction[directions[i]] += frequencies[b][i]
        });
      };
      
      console.log(
        `Données traitées: ${validDataCount} valides (${zeroSpeedCount} avec vitesse=0)`
      );

      // Vérifier qu'on a des données valides
      if (validDataCount === 0) {
        console.warn('Aucune donnée de vent valide trouvée');
        return null;
      }

      // Si toutes les vitesses sont nulles, retourner null pour afficher le message d'erreur
      if (zeroSpeedCount === validDataCount) {
        console.warn(
          'Toutes les vitesses sont à 0 - impossible de créer une rose des vents significative'
        );
        return null;
      }

    
      // Convertir les compteurs en pourcentages

      Object.keys(frequencies).forEach((bin) => {
        
        frequencies[bin] = frequencies[bin].map((count) =>
          validDataCount > 0
            ? parseFloat(((count / validDataCount) * 100).toFixed(1))
            : 0
        );
      });

      console.log(
        `Rose des vents générée avec ${validDataCount} points de données valides`
      );
      console.log('Répartition par vitesse:', {
        '0 m/s': zeroSpeedCount,
        autres: validDataCount - zeroSpeedCount,
      });

      console.warn(frequencies);
      return { directions, bins, frequencies };
    } catch (error) {
      console.error('Erreur lors du traitement des données de vent:', error);
      return null;
    }
  };
}

export default WindRose;